import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { IMAGES } from "@/data";

const testimonials = [
  {
    quote:
      "I was terrified of dentists my whole life. The team here completely changed that — gentle, patient and kind. I finally got my implants done!",
    name: "Sarah M.",
    detail: "Dental Implant Patient",
  },
  {
    quote:
      "No braces, no wires — my clear aligners gave me the straight smile I always wanted. The whole experience was so easy.",
    name: "Jaide L.",
    detail: "Clear Aligners",
  },
  {
    quote:
      "Took my two kids in for their free CDBS check-ups. Friendly staff, lovely clinic, and zero cost. Highly recommend to local families.",
    name: "Bec T.",
    detail: "Burpengary Mum",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-pd-bg">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <span className="text-xs uppercase tracking-[0.25em] font-medium text-pd-sage">Real Smiles</span>
            <h2 className="mt-4 font-display text-4xl lg:text-5xl font-medium leading-tight text-pd-forest">
              Smiles we've <span className="italic text-pd-accent">transformed.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-pd-accent text-pd-accent" />
              ))}
            </span>
            <span className="text-sm text-pd-body font-medium">Rated 5 stars on Google</span>
          </div>
        </div>

        {/* Smile gallery */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {IMAGES.gallery.map((src, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-image-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`relative rounded-3xl overflow-hidden group ${i % 3 === 0 ? "lg:row-span-2" : ""}`}
            >
              <img
                src={src}
                alt={`Patient smile ${i + 1}`}
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${i % 3 === 0 ? "h-72 lg:h-full" : "h-64"}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-pd-forest/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-pd-surface rounded-3xl p-8 flex flex-col"
            >
              <Quote size={32} className="text-pd-accent/40" />
              <p className="mt-4 text-pd-body leading-relaxed flex-1">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-pd-forest/10">
                <div className="font-display text-xl text-pd-forest">{t.name}</div>
                <div className="text-xs uppercase tracking-wider text-pd-sage mt-1">{t.detail}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
